import MuiBox from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';
import { forwardRef } from 'react';

export const Box = (props: BoxProps) => <MuiBox {...props} />;

export const RefBox = forwardRef((props: BoxProps, ref) => (
  <MuiBox {...props} ref={ref} />
));
